import type { Project, ProjectRepository } from './RepositoryInterfaces.js';

export class InMemoryProjectRepository implements ProjectRepository {
  private projects: Map<string, Project> = new Map();

  async findAll(): Promise<Project[]> {
    return Array.from(this.projects.values());
  }

  async findById(id: string): Promise<Project | undefined> {
    return this.projects.get(id);
  }

  async findByEnvironment(_environment?: string): Promise<Project[]> {
    return this.findAll();
  }

  async save(project: Project): Promise<Project> {
    this.projects.set(project.id, project);
    return project;
  }

  async delete(id: string): Promise<void> {
    this.projects.delete(id);
  }

  seed(projects: Project[]): void {
    projects.forEach((p) => this.projects.set(p.id, p));
  }
}

export const createInMemoryProjectRepository = (): InMemoryProjectRepository => new InMemoryProjectRepository();
